import React from 'react';
import subYears from 'date-fns/subYears';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData } from '../../types';
import { isYearOffset, periodToNumber } from '../../forms/utils/dateHelpers';
import { DatePicker } from '../../fields/DatePicker';

const MINIMUM_AGE = 15;

export const DateOfBirthField: React.FC<SmartformElementData> = (props) => {
  const [dateField] = getElementFields(props).required;
  const {
    name,
    helpText,
    label,
    validation: { required, max },
    error
  } = dateField;
  let years: number | undefined;
  if (isYearOffset(max?.[2])) {
    years = periodToNumber(max?.[2] ?? undefined, 'y');
  }

  const minDateValue: Date | undefined = (props.dependentValues?.[0] as Date | null) ?? undefined;

  return (
    <DatePicker
      name={name}
      key={name}
      helpText={helpText as any}
      label={label as any}
      required={required}
      errors={error}
      minDate={dateField.validation.minDate || minDateValue}
      minDateMessage={dateField.validation.minDateMessage}
      maxDate={subYears(new Date(), years ?? MINIMUM_AGE)}
      maxDateMessage={dateField.validation.maxDateMessage}
      dateFormat={props.element.params?.dateFormat}
      onChange={(value, setValue) => {
        setValue(value);
      }}
      disableFuture
    />
  );
};
